// Shared constants for ScraperDashboard components
// NOTE: Department data now comes from v_california_departments via useDepartments hook.
// Do NOT add hardcoded department lists here.

export const ACQ_TYPES = [
  'IT Goods',
  'IT Services',
  'Non-IT Goods',
  'Non-IT Services',
  'Public Works',
];

export const TIMEFRAMES = [
  { label: '1W',   days: 7 },
  { label: '1M',   days: 30 },
  { label: '1Y',   days: 365 },
  { label: '2Y',   days: 730 },
  { label: '3Y',   days: 1095 },
  { label: '5Y',   days: 1825 },
];

export function fmtDate(d) {
  return d.toISOString().split('T')[0];
}

// Extract BU code from a selectedDepartment object (various shapes from MainApp)
// Must return bu_code to match timeline data which uses bu_code for filtering
export function getDeptCode(selectedDepartment) {
  if (!selectedDepartment) return null;
  return selectedDepartment.bu_code
    || selectedDepartment.department_number
    || selectedDepartment.code
    || null;
}
